module.exports = __webpack_public_path__ + "static/media/gts23.0de70d09.png";